<div class="card card-table">
    <div class="card-body">
        <div class="prescription-items-container">
           <table class="table table-center">
  <thead>
    <tr>
      <th>Nom</th>
      <th *ngFor="let item of fillingsItmes; let i = index" style="width:25rem">
        <input
          class="form-control"
          [(ngModel)]="item.label"
          (ngModelChange)="_change()"
        />
      </th>
      <th></th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let item of fillingsItmes; let i = index">
      <td>Contenu</td>

      <td>
        <angular-editor
          [(ngModel)]="item.textContent"
          (ngModelChange)="_change()"
          [config]="config">
        </angular-editor>
      </td>

      <td>
        <a class="btn bg-danger-light" (click)="deleteFillingsItem(i)">
          <i class="feather-trash-2"></i>
        </a>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>
        <textarea draggable="true" class="form-control" style="border: transparent;">
          *[nom docteur] [nom patient] [date] [montant] [repos] [age]
        </textarea>
      </td>
    </tr>
  </tbody>
</table>

        </div>
    </div>
</div>